import * as Sentry from '@sentry/react';

export function initSentry() {
  // Initialize Sentry with your DSN
  const dsn = import.meta.env.VITE_SENTRY_DSN || 'https://ffcb0a9d701cef88886c88857c55b44c@o4510292457029632.ingest.de.sentry.io/4510292471119952';

  // Only initialize in production or if DSN is explicitly provided
  if (import.meta.env.PROD || import.meta.env.VITE_SENTRY_DSN) {
    Sentry.init({
      dsn,

      // Performance Monitoring
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
          maskAllText: true,
          blockAllMedia: true,
        }),
      ],

      // Performance Monitoring sample rate
      tracesSampleRate: 0.1, // 10% of transactions

      // Session Replay sample rate
      replaysSessionSampleRate: 0.1, // 10% of sessions
      replaysOnErrorSampleRate: 1.0, // 100% of sessions with errors

      // Environment
      environment: import.meta.env.MODE,

      // Release tracking
      release: import.meta.env.VITE_APP_VERSION || '1.0.0',

      // Setting this option to true will send default PII data to Sentry
      // For example, automatic IP address collection on events
      sendDefaultPii: true,

      // Ignore certain errors
      ignoreErrors: [
        // Browser extensions
        'top.GLOBALS',
        'chrome-extension://',
        'moz-extension://',
        // Network errors
        'NetworkError',
        'Failed to fetch',
        // Random plugins/extensions
        'atomicFindClose',
        // Facebook/Third-party
        'fb_xd_fragment',
      ],

      // Data scrubbing for sensitive information
      beforeSend(event) {
        // Scrub sensitive data from requests
        if (event.request) {
          // Keep cookies and headers for debugging but remove tokens
          if (event.request.headers) {
            // Mask Authorization header but keep that it exists
            if (event.request.headers.Authorization) {
              event.request.headers.Authorization = '[Filtered]';
            }
          }
        }

        return event;
      },
    });

    console.log('✅ Sentry initialized successfully');
  }
}

// Error boundary component
export const SentryErrorBoundary = Sentry.ErrorBoundary;

// Capture exceptions manually
export const captureException = Sentry.captureException;

// Capture messages
export const captureMessage = Sentry.captureMessage;

// Set user context
export const setUser = Sentry.setUser;

// Add breadcrumb
export const addBreadcrumb = Sentry.addBreadcrumb;
